export default {
  // Timers
  currentTimestamp: null,
  fetchedTimestamp: null,
  intervalId: null, // Just to clear on clean up.

  // 検索条件
  field: {
    area: null, // Number
    name: '', // String
    tel: '', // String
    customerCode: '' // String
  },
  // 検索結果
  result: [], // Customer{}[]
  loading: false, // sets to true everytime '検索' button in customerCondition is clicked

  csvUploadStatus: 0 // status of the uploaded CSV [-1: upload failed]
}
